module.exports = __webpack_public_path__ + "media/out2.97035657.mp4";